/**
 * Classes compartilhadas do design system (tokens de app/globals.css).
 * Escritas por extenso para o Tailwind encontrar.
 */

/** Superfície de popover e menu: fundo da página, linha fina, raio 12. */
export const DS_POPOVER =
  "rounded-xl border border-line bg-ground p-0 text-ink shadow-popover ring-0";

/** Campo de formulário: 38px no desktop, 44px e fonte de 16px no celular. */
export const DS_INPUT =
  "h-11 w-full min-w-0 rounded-md border border-line bg-field px-3 text-base text-ink outline-none transition-colors placeholder:text-ink-3 focus-visible:border-ink-2 focus-visible:ring-2 focus-visible:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-60 aria-invalid:border-alert md:h-9.5 md:text-sm";

/** Área de texto: mesmas bordas do campo, altura mínima de 78px. */
export const DS_TEXTAREA =
  "min-h-19.5 w-full min-w-0 rounded-md border border-line bg-field px-3 py-2.5 text-base text-ink outline-none transition-colors placeholder:text-ink-3 focus-visible:border-ink-2 focus-visible:ring-2 focus-visible:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-60 aria-invalid:border-alert md:text-sm";

/**
 * Item de menu: 44px no celular, 36px no desktop. O foco/hover é o painel
 * neutro — anula o `focus:bg-accent` do item do shadcn, que pintaria o item
 * com a cor principal do tenant.
 */
export const DS_MENU_ITEM =
  "flex h-11 w-full cursor-pointer items-center gap-2.5 px-3.5 text-left text-sm text-ink outline-none transition-colors hover:bg-panel focus:bg-panel focus:text-ink focus-visible:bg-panel data-[highlighted]:bg-panel not-data-[variant=destructive]:focus:**:text-current md:h-9";

/** Barra de informação da página de detalhe (EntityHeader `info`): uma
 *  linha fina em volta, texto de apoio e os links de ação à direita. */
export const DS_INFO_BAR =
  "flex flex-wrap items-center gap-x-4 gap-y-1 rounded-lg border border-line px-3.5 py-2.5 text-ui text-ink-2";
